import Constant from '@/const';
import axios from 'axios';

const getObstetricsAssessment = async idInpatient => {
  try {
    const response = await axios.get(
      Constant.apiUrl.concat(`/pregnancyassessment/${idInpatient}`),
    );
    return response;
  } catch (error) {
    return error;
  }
};

export default getObstetricsAssessment;
